import { FormControl, RadioGroup, Box, Typography } from "@mui/material";
import MapRawStringToReactElement from "lib/util/ReactComponentUtil/mapRawStringToReactElement/MapRawStringtoReactElement";
import RadioButton from "lib/components/formInputs/FullRadioButton/FullRadioButton";
import { CEQMSQuestionProps } from "./CEQMSQuestion.types";
import { sxStyles } from "./CEQMSQuestion.styles";
import { useAppSelector } from "lib/redux/hooks";
import { selectKioskQuestionnaire } from "ui/appointment/ducks/selectors";
import CheckBoxCard from "lib/components/cards/CheckBoxCard/CheckBoxCard";

const ANSWER_YES = "Yes";
const ANSWER_NO = "No";

const CEQMSQuestion = ({
  questionNumber,
  questionId,
  questionText,
  questionType,
  required,
  choices,
  handleQuestionnaireChange,
}: CEQMSQuestionProps) => {
  const classes = sxStyles();

  const questionAns = useAppSelector(selectKioskQuestionnaire).questionsAnswers;
  const ceqmsQuestionAns = useAppSelector(
    selectKioskQuestionnaire,
  ).ceqmsQuestionsAnswers;

  return (
    <FormControl component="fieldset" fullWidth>
      <Box sx={classes.formSameLine}>
        {questionNumber !== undefined && (
          <Typography sx={classes.questionNo}>
            {questionNumber + 1 + "."}
          </Typography>
        )}

        <Box sx={{ ...classes.fullWidth }}>
          {questionText && (
            <Typography sx={classes.questionBody}>
              {MapRawStringToReactElement(
                questionText.replace(/\\n/g, "<br/>"),
              )}
            </Typography>
          )}

          {questionType === "EQMS" ? (
            <RadioGroup
              name={"q" + questionId}
              value={choices}
              onChange={(event) => {
                const selectedValue = event.target.value;
                if (selectedValue === "true") {
                  handleQuestionnaireChange(true, "t", true);
                } else {
                  handleQuestionnaireChange(true, "f", true);
                }
              }}
            >
              <Box sx={classes.radioButtons}>
                <Box sx={{ mr: "10px" }}>
                  <RadioButton
                    checked={
                      questionAns ? questionAns[questionId] === true : false
                    }
                    label={ANSWER_YES}
                    value={true}
                  />
                </Box>
                <Box>
                  <RadioButton
                    checked={
                      questionAns ? questionAns[questionId] === false : false
                    }
                    label={ANSWER_NO}
                    value={false}
                  />
                </Box>
              </Box>
            </RadioGroup>
          ) : questionType === "Boolean" ? (
            <RadioGroup
              name={"q" + questionId}
              value={choices}
              onChange={(event) => {
                const selectedValue = event.target.value;
                if (selectedValue === "true") {
                  handleQuestionnaireChange(true, "t", true);
                } else {
                  handleQuestionnaireChange(true, "f", true);
                }
              }}
            >
              <Box sx={classes.radioButtons}>
                <Box sx={{ mr: "10px" }}>
                  <RadioButton
                    checked={
                      ceqmsQuestionAns &&
                      ceqmsQuestionAns[questionId] &&
                      ceqmsQuestionAns[questionId][0]
                        ? ceqmsQuestionAns[questionId][0] === "t"
                        : false
                    }
                    label={ANSWER_YES}
                    value={true}
                  />
                </Box>
                <Box>
                  <RadioButton
                    checked={
                      ceqmsQuestionAns &&
                      ceqmsQuestionAns[questionId] &&
                      ceqmsQuestionAns[questionId][0]
                        ? ceqmsQuestionAns[questionId][0] === "f"
                        : false
                    }
                    label={ANSWER_NO}
                    value={false}
                  />
                </Box>
              </Box>
            </RadioGroup>
          ) : questionType === "SingleSelect" && choices ? (
            <RadioGroup
              name={"q" + questionId}
              value={ceqmsQuestionAns}
              onChange={(event) => {
                const selectedValue = event.target.value;

                handleQuestionnaireChange(true, selectedValue, true);
              }}
            >
              <Box sx={classes.radioButtons}>
                {choices.map((choice, index) => (
                  <Box key={index} sx={{ mr: "10px" }}>
                    <RadioButton
                      checked={
                        ceqmsQuestionAns &&
                        ceqmsQuestionAns[questionId] &&
                        ceqmsQuestionAns[questionId][0]
                          ? ceqmsQuestionAns[questionId][0] === choice
                          : false
                      }
                      label={choice}
                      value={choice}
                    />
                  </Box>
                ))}
              </Box>
            </RadioGroup>
          ) : questionType === "MultiSelect" && choices ? (
            <>
              {choices.map((i) => {
                return (
                  <CheckBoxCard
                    title={i}
                    value={i}
                    checked={
                      ceqmsQuestionAns &&
                      ceqmsQuestionAns[questionId] &&
                      ceqmsQuestionAns[questionId][0]
                        ? ceqmsQuestionAns[questionId].includes(i)
                        : false
                    }
                    handleChange={(isChecked) =>
                      handleQuestionnaireChange(isChecked, i, false)
                    }
                  />
                );
              })}
            </>
          ) : null}
        </Box>
      </Box>
    </FormControl>
  );
};

export default CEQMSQuestion;
